import React from 'react';
import { Route, Link } from 'react-router-dom';

import App from '../App';
import Detail from './detail';
import Grid from './grid';

class Main extends React.Component {
  render() {
    return (
      <div>
        <h1>
          <Link to="/photos">My Photos</Link>
        </h1>
        <Route exact path = "/photos" component={App(Grid)}></Route>
        <Route path="/photos/view/:photoId" component={App(Detail)}></Route>
      </div>
    )
  }
};

export default Main;



// WEBPACK FOOTER //
// ./src/components/photogram/photos.js